import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(detail, fallback = "Se ha producido un error. Inténtelo de nuevo.") {
  const d = detail?.response?.data?.detail ?? detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return fallback;
}

// Transparent, single-flight refresh + one retry on 401.
let refreshPromise = null;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const noRetry = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/logout");
    if (status === 401 && !original._retry && !noRetry) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original); // retry once with fresh access cookie
      } catch (e) {
        if (typeof window !== "undefined") window.dispatchEvent(new Event("ddp-auth-expired"));
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
